import React, { Component } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import {
  profile,
  alert,
  toFixed,
  format_date,
  GET,
  POST,
  PUT,
  loading,
  params,
  required,
  Select,
  DatePicker,
  Navbar,
  Modal,
  XLSX,
  saveAs,
} from "../../components/CustomComponent.js";
import { NumericFormat } from "react-number-format";
export default class TransferMoneys extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_update: false,

      filter_broker: "",
      filter_start_date: format_date(
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() - 1
        ),
        "yyyy-mm-dd 00:00",
        "en"
      ),
      filter_end_date: format_date(new Date(), "yyyy-mm-dd 23:59", "en"),
      filter_acc: false,
      filter_currency: "THB",
      filter_type: "deposit",
      date: "",

      transfer_money_list: [],

      uid: params("uid") || "",
      gateway_amount: "",
      gateway_fee_vat: "",
      gateway_fee_transfer: "",
      gateway_amount_net: "",
      fee_transfer: "",

      data: [],
      loaded: false,
      count: 10,
      data_broker: [],
      data_gateway: [],

      deposits_fee_value: 0,

      tab:
        profile.user_type === "accounting"
          ? "history"
          : params("tab") || "create",

          detail: null
    };
  }

  async componentDidMount() {
    loading(false);
    await Promise.all([this.GetMaster(), this.Get(0)]);
  }

  // ตัวเลือกของ dropdown ทั้งหน้า ไม่เปลี่ยนระหว่างอยู่บนหน้านี้ ดึงครั้งเดียวตอนเปิดหน้า
  // ไม่ยุ่งกับ loading เพราะ Get เป็นคนคุมสถานะโหลดของตาราง
  GetMaster = async () => {
    let data_broker, deposits_fee_value;
    let [result_broker, result_gateway] = await Promise.all([
      GET("v1/admin/brokers/options", {
        page_size: 100000,
        page: 0,
        data_search: "",
      }),
      GET("gateway-rules/list", { page_size: 100000, page: 0, data_search: "" }),
    ]);
    if (result_broker?.status) {
      data_broker = result_broker.data.map((e) => ({
        value: e.uid,
        label: e.name_en,
        gateway: e.gateway_deposits,
        id: e.id
      }));
    }
    if (result_broker?.status) {
      deposits_fee_value =
        result_gateway.data.find((e) => e.gateway_name === "payso")
          ?.deposits_fee_value || 0;
    }
    this.setState({ data_broker, deposits_fee_value: Number(deposits_fee_value) });
  };
  Get = async (page) => {
    let data, count;

    const {
      filter_start_date,
      filter_end_date,
      filter_broker,
      filter_currency,
      filter_type,
    } = this.state;
    loading(true);

    let [result] = await Promise.all([
      GET("v1/account/transfer-moneys", {
        page_size: 10,
        page: page,
        broker_id: filter_broker,
        start_date: format_date(filter_start_date, "yyyy-mm-dd hh:mm:ss", "en"),
        end_date: format_date(filter_end_date, "yyyy-mm-dd hh:mm:ss", "en"),
        currency: filter_currency || "THB",
        type: filter_type,
      }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    this.setState({
      data,
      loaded: true,
      count,
    });
    loading(false);
  };

  GetByAccID = async () => {
    const {
      filter_start_date,
      filter_end_date,
      filter_broker,
      filter_currency,
      filter_type,
    } = this.state;
    let transfer_money_list;
    if (!filter_start_date.trim()) {
      alert("", "warning", "Warning", "Please select Start Date");
      return;
    }
    if (!filter_end_date.trim()) {
      alert("", "warning", "Warning", "Please select End Date");
      return;
    }
    if (filter_start_date && filter_end_date) {
      loading(true);

      let result = await GET("v1/account/transfer-moneys/acc", {
          uid: filter_broker,
          start_date: format_date(filter_start_date, "yyyy-mm-dd hh:mm:ss", "en"),
          end_date: format_date(filter_end_date, "yyyy-mm-dd hh:mm:ss", "en"),
          currency: filter_currency || "THB",
          type: filter_type,
        })
      ;
      if (result?.status) {
        transfer_money_list = result.data.map(e=>({
          ...e,
          gateway_amount: e.gateway_amount || 0,
            gateway_fee_vat: e.gateway_fee_vat || 0,
            gateway_fee_transfer: e.gateway_fee_transfer || 0,
            gateway_amount_net: e.gateway_amount_net || 0,
            
            total_amount: e.total_amount || 0,
            total_amount_net: e.total_amount_net || 0,
            total_fee: e.total_fee || 0,
            total_vat: e.total_vat || 0,
            total_fee_vat: e.total_fee_vat || 0,

            fee_transfer: e.fee_transfer || 0,
            transfer_revenue: e.transfer_revenue || 0,
            transfer_payout: e.transfer_payout || 0,
            deposit_fee_value: e.deposit_fee_value || 0,
            deposit_fee_type: e.deposit_fee_type || "",
            withdrawal_fee_value: e.withdrawal_fee_value || 0,
            withdrawal_fee_type: e.withdrawal_fee_type || "",
        }));
      }

      this.setState({ transfer_money_list });
      loading(false);
    }
  };
  GetByID = async (uid) => {
    loading(true);

    let result = await GET("v1/account/transfer-moneys", { uid });
    if (result?.status) {
      this.setState({ detail: {...result.data,
        gateway_amount: Number(result.data.gateway_amount),
        gateway_fee_transfer: Number(result.data.gateway_fee_transfer),
        fee_transfer: Number(result.data.fee_transfer),
      }, 
      uid,
      modal_update: true });
    }

    loading(false);
  };

  Create = async () => {
    const {
      filter_start_date,
      filter_end_date,
      transfer_money_list,
      filter_type,

      filter_currency,
    } = this.state;
    for (let item of transfer_money_list) {
      if (!item.gateway_amount?.toString().trim()) {
        alert("", "warning", "Warning", "Please input gateway amount");
        return;
      } else if (!item.gateway_fee_transfer?.toString().trim()) {
        alert("", "warning", "Warning", "Please input gateway fee transfer");
        return;
      } else if (!item.fee_transfer?.toString().trim()) {
        alert("", "warning", "Warning", "Please input fee transfer");
        return;
      }
    }

    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      const result = await Promise.all(
        transfer_money_list.map((item, index) => {
          let fee = 
          filter_type === "deposit" ?
          ((item.deposit_fee_type === "percentage" ? Number(item.gateway_amount) / 100 : 1) * Number(item?.deposit_fee_value)) : 
          ((item.withdrawal_fee_type === "percentage" ? Number(item.gateway_amount) / 100 : 1) * Number(item?.withdrawal_fee_value))
          ;
          let vat = fee * 0.07;
          let feeVat = fee + vat;
          let amountNet =
            Number(item.gateway_amount) -
            feeVat -
            Number(item.gateway_fee_transfer);

          let body = {
            start_date: format_date(
              filter_start_date,
              "yyyy-mm-dd hh:mm:ss",
              "en"
            ),
            end_date: format_date(filter_end_date, "yyyy-mm-dd hh:mm:ss", "en"),
            broker_id: item.broker_uid || "",
            merchant_id: item?.merchant_id || "",

            gateway_amount: Number(toFixed(Number(item.gateway_amount) || 0, 2).replaceAll(",", "")),
            gateway_fee_vat: Number(toFixed(Number(feeVat) || 0, 2).replaceAll(",", "")),
            gateway_fee_transfer: Number(toFixed(Number(item.gateway_fee_transfer) || 0, 2).replaceAll(",", "")),
            gateway_amount_net: Number(toFixed(Number(amountNet) || 0, 2).replaceAll(",", "")),
            
            total_amount: Number(toFixed(Number(item?.total_amount), 2).replaceAll(",", "")),
            total_amount_net: Number(toFixed(Number(item?.total_amount_net) || 0, 2).replaceAll(",", "")),
            total_fee: Number(toFixed(Number(item?.total_fee) || 0, 2).replaceAll(",", "")),
            total_vat: Number(toFixed(Number(item?.total_vat) || 0, 2).replaceAll(",", "")),
            total_fee_vat: Number(toFixed(Number(item?.total_vat) + Number(item?.total_fee), 2).replaceAll(",", "")),

            fee_transfer: Number(toFixed(Number(item.fee_transfer) || 0, 2).replaceAll(",", "")),
            transfer_revenue: Number(toFixed(Number(item?.total_fee_vat) - Number(feeVat) - Number(item.fee_transfer), 2).replaceAll(",", "")),
            transfer_payout: Number(toFixed(item?.total_amount_net).replaceAll(",", "")),
            deposit_fee_value:  Number(toFixed(item?.deposit_fee_value).replaceAll(",", "")),
            deposit_fee_type:  item?.deposit_fee_type,
            withdrawal_fee_value:  Number(toFixed(item?.withdrawal_fee_value).replaceAll(",", "")),
            withdrawal_fee_type:  item?.withdrawal_fee_type,
            currency: filter_currency,
            type: filter_type,
          };
          return POST("v1/account/transfer-moneys", body);
        })
      );

      if (result?.every((e) => e.status === true)) {
        this.setState({
          filter_broker: "",
          transfer_money_list: [],
        });
        alert("", "success", "Success", "Submit successfully");
      } else {
        alert("", "warning", "Warning", "An error occurred. Please try again.");
      }
      loading(false);
    }
  };

  Update = async () => {
    const {
      uid,
      detail
    } = this.state;
    const item = detail;
    if (!item?.gateway_amount.toString().trim()) {
      alert("", "warning", "Warning", "Please input gateway amount");
      return;
    } else if (!item?.gateway_fee_transfer.toString().trim()) {
      alert("", "warning", "Warning", "Please input gateway fee transfer");
      return;
    } else if (!item?.fee_transfer.toString().trim()) {
      alert("", "warning", "Warning", "Please input fee transfer");
      return;
    }

    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);

      let fee = 
          item?.type === "deposit" ?
          ((item.deposit_fee_type === "percentage" ? Number(item.gateway_amount) / 100 : 1) * Number(item?.deposit_fee_value)) : 
          ((item.withdrawal_fee_type === "percentage" ? Number(item.gateway_amount) / 100 : 1) * Number(item?.withdrawal_fee_value))
          ;
          let vat = fee * 0.07;
          let feeVat = fee + vat;
          let amountNet =
            Number(item.gateway_amount) -
            feeVat -
            Number(item.gateway_fee_transfer);

          let body = {
            gateway_amount: Number(
              toFixed(Number(item.gateway_amount) || 0, 2).replaceAll(",", "")
            ),
            gateway_fee_vat: Number(
              toFixed(Number(feeVat) || 0, 2).replaceAll(",", "")
            ),
            gateway_fee_transfer: Number(
              toFixed(Number(item.gateway_fee_transfer) || 0, 2).replaceAll(
                ",",
                ""
              )
            ),
            gateway_amount_net: Number(
              toFixed(Number(amountNet) || 0, 2).replaceAll(",", "")
            ),

            total_amount: Number(
              toFixed(Number(item?.total_amount), 2).replaceAll(",", "")
            ),
            total_amount_net: Number(
              toFixed(Number(item?.total_amount_net) || 0, 2).replaceAll(
                ",",
                ""
              )
            ),
            total_fee_vat: Number(
              toFixed(
                Number(item?.total_vat) + Number(item?.total_fee),
                2
              ).replaceAll(",", "")
            ),

            fee_transfer: Number(
              toFixed(Number(item.fee_transfer) || 0, 2).replaceAll(",", "")
            ),
            transfer_revenue: Number(
              toFixed(
                (Number(item?.total_vat) + Number(item?.total_fee)) -
                  Number(feeVat) -
                  Number(item.fee_transfer),
                2
              ).replaceAll(",", "")
            ),
            transfer_payout: Number(
              toFixed(item?.total_amount_net).replaceAll(",", "")
            ),
          };

      let result = await PUT("v1/account/transfer-moneys/" + uid, body);
      if (result?.status === true) {
        this.setState({
          transfer_money_list: [],
          modal_update: false,
        });
        alert("", "success", "Success", "Submit successfully");
        this.Get(1);
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };

  ExportCSV = async () => {
    loading(true);
    const {data_broker, filter_start_date, filter_end_date, filter_broker, filter_currency, filter_type} = this.state;
    let result = await GET("v1/account/transfer-moneys/transactions", {
      uid: filter_broker,
      start_date: format_date(filter_start_date, "yyyy-mm-dd hh:mm:ss", "en"),
      end_date: format_date(filter_end_date, "yyyy-mm-dd hh:mm:ss", "en"),
      currency: filter_currency || "THB",
      type: filter_type,
    });
    console.log("result:",result)
    if (result?.status === true) {
      const transaction_list = result.data;
      // EXPORT CSV
      const json_data = transaction_list.map((item) => ({
        Time: format_date(item.created_at, "dd/mm/yy hh:mm", "en"),
        RefNo: item.ref_no,
        RefQR: item.reference_id,
        Amount: toFixed(item.amount, 2),
        "Fee%": toFixed(item.fee_rate, 2),
        Fee: toFixed(item.fee, 2),
        Vat: toFixed(item.vat, 2),
        "Amount Net": toFixed(item.amount_net, 2),
        Process: item.process_type.toLowerCase(),
        Status: item.status || "-",
        currency: item.currency,
        gateway: item.gateway,
        broker: item.broker_id
      }));
      // 1. Convert JSON to worksheet
      
      // 2. Create a new workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      console.log("data_broker:",data_broker)
      const worksheet_thb = XLSX.utils.json_to_sheet(json_data.map(e=>({...e,broker: data_broker.find(b=>b.id === e.broker)?.label})));
      XLSX.utils.book_append_sheet(workbook, worksheet_thb, `${filter_currency} (${json_data?.length || 0})`);

      for(let item of data_broker){
        const worksheet_lak = XLSX.utils.json_to_sheet(json_data?.filter((e) => e.broker === item.id)?.map(e=>({...e,broker: item.label})));
        XLSX.utils.book_append_sheet(workbook, worksheet_lak, `${item.label} (${json_data?.filter((e) => e.broker === item.id)?.length})`);
      }

      // 3. Write the workbook to binary buffer
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

      // 4. Save to file
      const data = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(data, `transfer-money-${format_date( filter_start_date, "dd/mm/yy hh:mm:ss", "en" )}-${format_date(filter_end_date, "dd/mm/yy hh:mm:ss", "en")}-${filter_currency}.xlsx`);
    }

    loading(false);
  };

  // -------------------------------------------------------------------------
  // Render helpers (presentation only — Get / GetByAccID / Create / Update /
  // ExportCSV and every calculation are unchanged)
  // -------------------------------------------------------------------------
  kv = (label, value, opts = {}) => (
    <div className={`pu-kv ${opts.total ? "total" : ""} ${opts.className || ""}`}>
      <span className="pu-kv-label">{label}</span>
      <span className={`pu-kv-value ${opts.valueClass || ""}`}>{value}</span>
    </div>
  );
  kvInput = (label, value, onValueChange, required_) => (
    <div className="pu-kv input">
      <span className="pu-kv-label">
        {label}
        {required_ ? required : null}
      </span>
      <NumericFormat
        thousandSeparator=","
        decimalScale={2}
        type="text"
        className="form-control pr-input pu-kv-input"
        placeholder="0.00"
        value={value}
        onValueChange={onValueChange}
      />
    </div>
  );
  // One transfer card (create list item or the update modal detail). `commit`
  // is the same setState the original code called after mutating the item.
  renderTransferCard = (item, commit, key) => {
    const { filter_type, filter_currency } = this.state;
    let fee =
      filter_type === "deposit"
        ? (Number(item?.gateway_amount) * Number(item?.deposit_fee_value)) / 100
        : (Number(item?.gateway_amount) * Number(item?.withdrawal_fee_value)) / 100;
    let vat = fee * 0.07;
    let feeVat = fee + vat;
    let amountNet =
      Number(item?.gateway_amount) - feeVat - Number(item?.gateway_fee_transfer || 0);
    const feeRate = toFixed(
      filter_type === "deposit" ? item?.deposit_fee_value : item?.withdrawal_fee_value,
      2
    );
    const sgpFeeLabel =
      filter_type === "deposit"
        ? item?.deposit_fee_type === "percentage"
          ? `(${toFixed(item?.deposit_fee_value, 2)}%)`
          : ""
        : item?.withdrawal_fee_type === "percentage"
        ? `(${toFixed(item?.withdrawal_fee_value, 2)}%)`
        : "";
    const matched =
      toFixed(item?.gateway_amount, 2) === toFixed(item?.total_amount, 2);
    const brokerName = item?.name_en || item?.name_th || "-";
    const revenue =
      Number(item?.total_vat || 0) +
      Number(item?.total_fee || 0) -
      Number(feeVat || 0) -
      Number(item?.fee_transfer || 0);
    return (
      <div className="ar-table-card pu-transfer mb-3" key={key}>
        <div className="ar-table-head">
          <div className="pu-user">
            <div className="pu-avatar">{brokerName.trim().charAt(0).toUpperCase()}</div>
            <div className="min-w-0">
              <div className="ar-table-title text-truncate">{brokerName}</div>
              <div className="ar-table-caption">
                <span className="pu-code me-2">
                  {item?.merchant_id || item?.gateway?.toUpperCase() || "-"}
                </span>
                {filter_type === "deposit" ? "Deposit" : "Withdrawal"} · {filter_currency}
              </div>
            </div>
          </div>
          <span className={`pu-flag ${matched ? "on" : "warn"}`}>
            <span className="icon">{matched ? "" : ""}</span>
            {matched ? "Amount matched" : "Amount mismatch"}
          </span>
        </div>
        <div className="pu-transfer-body">
          <div className="row g-3">
            {/* GATEWAY */}
            <div className="col-12 col-lg-4">
              <div className="pu-section pu-section-dep h-100 mb-0">
                <div className="pu-section-title">
                  <span className="icon">{""}</span>Gateway
                </div>
                {this.kv(
                  "Description",
                  <span className="pu-transfer-desc">
                    {item?.merchant_id || item?.gateway?.toUpperCase() || "-"}
                  </span>
                )}
                {this.kvInput(
                  "Amount",
                  item?.gateway_amount,
                  (values) => {
                    item.gateway_amount = values.value;
                    commit();
                  },
                  true
                )}
                {this.kv(`Fee (${feeRate}%)`, toFixed(fee, 2))}
                {this.kv("Vat 7%", toFixed(vat, 2))}
                {this.kv("Fee + Vat", toFixed(feeVat, 2))}
                {this.kvInput(
                  "Fee Transfer",
                  item?.gateway_fee_transfer,
                  (values) => {
                    item.gateway_fee_transfer = values.value;
                    commit();
                  },
                  true
                )}
                {this.kv("Amount Net", toFixed(amountNet, 2), { total: true })}
              </div>
            </div>
            {/* SWIFTGOLDPAY */}
            <div className="col-12 col-lg-4">
              <div className="pu-section pu-section-gold h-100 mb-0">
                <div className="pu-section-title">
                  <span className="icon">{""}</span>SwiftGoldPay
                </div>
                {this.kv(
                  "Amount",
                  item?.total_amount ? toFixed(item?.total_amount, 2) : "0.00",
                  { valueClass: matched ? "text-success" : "text-danger" }
                )}
                {this.kv(`Fee ${sgpFeeLabel}`, toFixed(Number(item?.total_fee), 2) || "0.00")}
                {this.kv("Vat", toFixed(Number(item?.total_vat), 2) || "0.00")}
                {this.kv(
                  "Fee + Vat",
                  toFixed(Number(item?.total_vat) + Number(item?.total_fee), 2) || "0.00"
                )}
                {this.kv(
                  "Amount Net",
                  item?.total_amount_net ? toFixed(item?.total_amount_net, 2) : "0.00",
                  { total: true }
                )}
              </div>
            </div>
            {/* TOTAL */}
            <div className="col-12 col-lg-4">
              <div className="pu-section pu-section-wd h-100 mb-0">
                <div className="pu-section-title">
                  <span className="icon">{""}</span>Total
                </div>
                {this.kvInput("Fee Transfer", item?.fee_transfer, (values) => {
                  item.fee_transfer = values.value;
                  commit();
                })}
                {this.kv("Transfer Revenue", toFixed(revenue, 2), {
                  valueClass: revenue < 0 ? "text-danger" : "",
                })}
                {this.kv(
                  "Transfer Payout",
                  item?.total_amount_net ? toFixed(item?.total_amount_net, 2) : "0.00",
                  { total: true }
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  switchTab = (next) => {
    if (next === "create") {
      this.setState({
        tab: "create",
        filter_start_date: format_date(
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate() - 1
          ),
          "yyyy-mm-dd 00:00",
          "en"
        ),
        filter_end_date: format_date(new Date(), "yyyy-mm-dd 23:59", "en"),
      });
      return;
    }
    this.setState({
      tab: "history",
      filter_start_date: format_date(
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        "yyyy-mm-dd 00:00",
        "en"
      ),
      filter_end_date: format_date(new Date(), "yyyy-mm-dd 23:59", "en"),
    });
    this.Get(1);
  };
  render() {
    const {
      modal_update,

      uid,
      filter_start_date,
      filter_end_date,
      filter_broker,
      filter_acc,
      filter_currency,
      filter_type,
      data,
      loaded,
      data_broker,
      tab,
      transfer_money_list,

      detail
    } = this.state;
    const rows = Array.isArray(data) ? data : [];
    const commitList = () => this.setState({ transfer_money_list });
    // แยกส่วนวันและเวลาออกจาก string "yyyy-mm-dd HH:MM" ที่เก็บใน state
    const dateOf = (v) => (v ? String(v).slice(0, 10) : "");
    const timeOf = (v) => (v && String(v).length >= 16 ? String(v).slice(11, 16) : "");
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className={`body p-3 mt-3 ${tab === "create" && transfer_money_list.length ? "pu-has-actionbar" : ""}`}>
          {/* HERO */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Payment</div>
                <div className="ar-title">
                  Transfer Money Reports {uid ? "(Update)" : ""}
                </div>
                <div className="ar-subtitle">Daily transfer money between gateway and SwiftGoldPay</div>
              </div>
              {profile.user_type !== "accounting" && (
                <div className="pu-tabs pu-tabs-dark mb-0">
                  <button
                    type="button"
                    className={`pu-tab ${tab === "create" ? "active" : ""}`}
                    onClick={() => this.switchTab("create")}
                  >
                    <span className="icon me-2">{""}</span>Create
                  </button>
                  <button
                    type="button"
                    className={`pu-tab ${tab === "history" ? "active" : ""}`}
                    onClick={() => this.switchTab("history")}
                  >
                    <span className="icon me-2">{""}</span>History
                  </button>
                </div>
              )}
            </div>

            {/* FILTER */}
            <div className="ar-toolbar ar-filter mt-3">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label">
                  <span className="icon me-2">{""}</span>
                  {tab === "create" ? "Data for create" : "Filter"}
                </span>
              </div>
              <div className="ar-filter-row">
              <div className="ar-filter-field ar-filter-field-auto">
                <span className="ar-filter-label">Period</span>
                <div className="d-flex align-items-center gap-2 flex-nowrap">
              {/* วันเริ่ม/สิ้นสุดแยกกัน แต่ละชุดมี DatePicker ของโปรเจกต์ + ช่องเวลา
                  state ยังเป็น string "yyyy-mm-dd HH:MM" รูปแบบเดิม โหมด ACC ล็อกเวลาเป็น 21:00–20:59 */}
              {[
                { key: "filter_start_date", label: "From", value: filter_start_date, accTime: "21:00", defTime: "00:00" },
                { key: "filter_end_date", label: "To", value: filter_end_date, accTime: "20:59", defTime: "23:59" },
              ].map((f) => (
                <div className="pu-dt" key={f.key}>
                  <span className="pu-dt-label">{f.label}</span>
                  <div className="wpx-140">
                    <DatePicker
                      className="form-control pu-dt-date"
                      placeholder="Date..."
                      value={dateOf(f.value)}
                      onChange={(d) => {
                        this.setState({
                          [f.key]: d
                            ? `${d} ${filter_acc ? f.accTime : timeOf(f.value) || f.defTime}`
                            : "",
                        });
                      }}
                    />
                  </div>
                  <input
                    type="time"
                    className="form-control pu-time"
                    title={`${f.label} time`}
                    disabled={filter_acc}
                    value={timeOf(f.value)}
                    onChange={(e) => {
                      if (!e.target.value) return;
                      this.setState({
                        [f.key]: `${dateOf(f.value) || format_date(new Date(), "yyyy-mm-dd", "en")} ${e.target.value}`,
                      });
                    }}
                  />
                </div>
              ))}
              <label className={`pu-acc ${filter_acc ? "on" : ""}`} title="Accounting day (21:00 – 20:59)">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    this.setState({
                      filter_acc: e.target.checked,
                      filter_start_date: format_date(filter_start_date, "yyyy-mm-dd 21:00", "en"),
                      filter_end_date: format_date(filter_end_date, "yyyy-mm-dd 20:59", "en"),
                    });
                  }}
                  checked={filter_acc}
                />
                <span className="icon me-1">{filter_acc ? "" : ""}</span>
                ACC
              </label>
                </div>
              </div>
              <div className="ar-filter-field">
                <span className="ar-filter-label">Type</span>
                <Select
                  className="form-control"
                  placeholder="Type"
                  options={[
                    { value: "deposit", label: "Deposit" },
                    { value: "withdrawals", label: "Withdrawal" },
                  ]}
                  value={filter_type}
                  onChange={(v) => {
                    this.setState({
                      filter_type: v,
                    });
                  }}
                />
              </div>
              <div className="ar-filter-field">
                <span className="ar-filter-label">Broker</span>
                <Select
                  className="form-control"
                  placeholder="All brokers"
                  options={data_broker}
                  onChange={(e, i) => {
                    this.setState({ filter_broker: e });
                  }}
                  value={filter_broker}
                />
              </div>
              <div className="ar-toolbar-actions">
              <button
                className="ar-btn-gold"
                onClick={() => {
                  if (tab === "create") {
                    this.GetByAccID();
                  } else {
                    this.Get(1);
                  }
                }}
              >
                <span className="icon me-2">{""}</span>Search
              </button>
              </div>
              </div>
              <div className="ar-filter-foot">
              <div className="d-flex align-items-center gap-2">
                {global.currency?.map((item) => (
                  <button
                    key={item.currency_code}
                    className={`ar-pill ${
                      item.currency_code === filter_currency ? "active" : ""
                    }`}
                    onClick={() => {
                      this.setState({
                        filter_currency: item.currency_code,
                      });
                    }}
                  >
                    {item.image}
                    <span className="ms-1">{item.currency_code}</span>
                  </button>
                ))}
              </div>
              </div>
            </div>
          </div>

          {/* CREATE */}
          {tab === "create" && (
            <div className="mb-3">
              {transfer_money_list.length === 0 && loaded && (
                <div className="pr-empty">
                  <span className="icon">{""}</span>
                  <div className="fw-bold">No transfer data</div>
                  <div className="text-secondary text-14">
                    Choose a currency, period, type and broker, then press Search.
                  </div>
                </div>
              )}
              {transfer_money_list.map((item, index) =>
                this.renderTransferCard(item, commitList, `transfer-${index}`)
              )}
            </div>
          )}
          {tab === "create" && transfer_money_list.length !== 0 && (
            <div className="pu-actionbar">
              <div className="pu-actionbar-info d-none d-md-block">
                <b>{transfer_money_list.length}</b> transfer{transfer_money_list.length === 1 ? "" : "s"} ready
              </div>
              <button
                className="ar-btn-ghost dark"
                onClick={async () => {
                  this.ExportCSV();
                }}
              >
                <span className="icon me-2">{""}</span>Export CSV
              </button>
              <button
                className="ar-btn-gold transfer-moneys.create"
                onClick={() => {
                  this.Create();
                }}
              >
                <span className="icon me-2">{""}</span>Submit
              </button>
              <button
                className="ar-btn-ghost dark"
                onClick={() => {
                  window.location.reload();
                }}
              >
                Reset
              </button>
            </div>
          )}

          {/* HISTORY */}
          {tab === "history" && (
            <div className="ar-table-card">
              <div className="ar-table-head">
                <div>
                  <div className="ar-table-title">
                    <span className="icon me-2 pu-title-icon">{""}</span>
                    Transfer History
                  </div>
                  <div className="ar-table-caption">
                    {rows.length} record{rows.length === 1 ? "" : "s"} · {filter_currency}
                  </div>
                </div>
                <div className="d-none d-md-flex align-items-center gap-3 ar-legend">
                  <span><i className="ar-legend-dot ar-legend-dep"></i>Payment Gateway</span>
                  <span><i className="ar-legend-dot ar-legend-gold"></i>SwiftGoldPay</span>
                  <span><i className="ar-legend-dot ar-legend-wd"></i>Summary</span>
                </div>
              </div>
              <div className="table-responsive">
                <table className="table table-hover text-nowrap ar-table pu-table">
                  <thead>
                    <tr>
                      <td className="align-middle" rowSpan={2}>Date</td>
                      <td className="align-middle" rowSpan={2}>Period</td>
                      <td className="align-middle ar-sticky" rowSpan={2}>Broker</td>
                      <td className="text-center ar-group ar-group-dep ar-group-start" colSpan={5}>
                        <span className="icon me-2">{""}</span>Payment Gateway
                      </td>
                      <td className="text-center ar-group ar-group-gold ar-group-start" colSpan={3}>
                        <span className="icon me-2">{""}</span>SwiftGoldPay
                      </td>
                      <td className="text-center ar-group ar-group-wd ar-group-start" colSpan={3}>
                        <span className="icon me-2">{""}</span>Summary
                      </td>
                      <td className="align-middle text-center transfer-moneys.update td-actions" rowSpan={2}>Actions</td>
                    </tr>
                    <tr>
                      <td className="ar-group-start">Description</td>
                      <td className="text-end">Amount</td>
                      <td className="text-end">Fee + Vat</td>
                      <td className="text-end">Fee Transfer</td>
                      <td className="text-end ar-head-profit">Amount Net</td>
                      <td className="text-end ar-group-start">Amount</td>
                      <td className="text-end">Fee + Vat</td>
                      <td className="text-end ar-head-profit">Amount Net</td>
                      <td className="text-end ar-group-start">Fee Transfer</td>
                      <td className="text-end">Transfer Revenue</td>
                      <td className="text-end ar-head-profit">Transfer Payout</td>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((item, index) => (
                      <tr key={item.uid || `array-${index}`}>
                        <td data-label="Date">
                          <div className="ar-month-badge">
                            <span>{format_date(item.created_at, "dd", "en")}</span>
                            {format_date(item.created_at, "dd/mm/yyyy", "en")}
                          </div>
                        </td>
                        <td data-label="Period">
                          <div className="pu-period">
                            <span>{format_date(item.start_date, "dd/mm/yyyy HH:MM", "en")}</span>
                            <span className="pu-sub">→ {format_date(item.end_date, "dd/mm/yyyy HH:MM", "en")}</span>
                          </div>
                        </td>
                        <td data-label="Broker" className="ar-sticky ar-broker">
                          {item.broker?.name_en || item.broker?.name_th || "-"}
                        </td>
                        <td data-label="(PG) Description" className="ar-group-start">
                          <span className="pu-code">{item.merchant_id || "-"}</span>
                        </td>
                        <td data-label="(PG) Amount" className="text-end">{toFixed(item.gateway_amount)}</td>
                        <td data-label="(PG) Fee + Vat" className="text-end ar-muted">{toFixed(item.gateway_fee_vat)}</td>
                        <td data-label="(PG) Fee Transfer" className="text-end ar-muted">{toFixed(item.gateway_fee_transfer)}</td>
                        <td data-label="(PG) Net" className="text-end ar-dep-profit">{toFixed(item.gateway_amount_net)}</td>
                        <td data-label="(SGP) Amount" className="text-end ar-group-start">{toFixed(item.total_amount)}</td>
                        <td data-label="(SGP) Fee + Vat" className="text-end ar-muted">{toFixed(item.total_fee_vat)}</td>
                        <td data-label="(SGP) Net" className="text-end fw-bold">{toFixed(item.total_amount_net)}</td>
                        <td data-label="(SUM) Fee Transfer" className="text-end ar-group-start ar-muted">{toFixed(item.fee_transfer)}</td>
                        <td data-label="(SUM) Revenue" className={`text-end ${Number(item.transfer_revenue) < 0 ? "ar-neg" : "ar-wd-profit"}`}>
                          {toFixed(item.transfer_revenue)}
                        </td>
                        <td data-label="(SUM) Payout" className="text-end fw-bold">{toFixed(item.transfer_payout)}</td>
                        <td data-label="Actions" className="text-center transfer-moneys.update td-actions">
                          <Dropdown align="end">
                            <Dropdown.Toggle className="pu-action-toggle" id={`transfer-actions-${index}`}>Action</Dropdown.Toggle>
                            <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                              <Dropdown.Item className="pu-action-item transfer-moneys.update" onClick={() => {
                                this.GetByID(item.uid);
                              }}>
                                <span className="icon">{""}</span>Update
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                    {loaded && rows.length === 0 && (
                      <tr>
                        <td colSpan={16} className="text-center py-5">
                          <div className="ar-empty">
                            <span className="icon d-block mb-2">{""}</span>
                            No transfer history for this period
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>

        {/* CREATE UPDATE */}
        <Modal
          show={modal_update}
          onHide={() => this.setState({ modal_update: false })}
          size={"xl"}
          dialogClassName="pr-modal pr-scope pu-scope"
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Transfer money</div>
              <h5 className="fw-bold mb-0">Update Transfer Money</h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            {detail
              ? this.renderTransferCard(detail, commitList, "transfer-detail")
              : null}
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-dark px-5 me-1 rounded-pill transfer-moneys.update"
              onClick={() => {
                this.Update();
              }}
            >
              Submit
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1 rounded-pill"
              onClick={() => {
                this.setState({ modal_update: false });
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
